<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['links']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.ColorSelect({
              label: 'Kolor (domyślnie Podstawowy)',
              modelPath: [this, 'form', 'color']
            }),
            new fields.Header({
              type: 'h3',
              text: 'Linki'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'links'],
              items: this.form.links.map((itemLink, i) => {
                return {
                  headerLabel: itemLink.prefix_pl,
                  fields: [
                    new fields.Input({
                      label: 'Prefix',
                      modelPath: [this, 'form', 'links', i, 'prefix'],
                      multilingual: true
                    }),
                    new fields.Link({
                      label: 'Link',
                      modelPath: [this, 'form', 'links', i, 'link'],
                      required: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
